import './customer-section.sass';
import { Container, Row, Col, Image } from 'react-bootstrap';
import android_pic from '../../assets/images/android.png';
import ios_pic from '../../assets/images/ios.png';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const customer_android_href = 'https://play.google.com/';
const customer_ios_href = 'https://www.apple.com/pt/app-store/';

function Customer() {
  const { t } = useTranslation();

  return (
    <Container fluid className='customer-container'>
      <Row className="customer-slogan">
        <Col>
          <p className='intro-delivery'>
            <Trans i18nKey="delivery_message" />
          </p>
        </Col>
        <div className="customer-main">
          <Col>
            <h1 className="h1-title-1">
              <Trans i18nKey="home_services_title" />
            </h1>
          </Col>
          <Col>
            <h1 className="h1-title-2">
              <Trans i18nKey="home_services_subtitle" />
            </h1>
          </Col>
          <Col>
            <div className="buttons-container-pic">
              <div className="buttons-links">
                <a
                  href={customer_android_href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={android_pic}
                    className="android-pic"
                    alt="android-pic"
                  />
                </a>
                <a
                  href={customer_ios_href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ios_pic} className="ios-pic" alt="ios-pic" />
                </a>
              </div>
            </div>
          </Col>
        </div>
      </Row>
    </Container>
  );
}

export { Customer };
